import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface NewItemBadgeProps {
  isNew?: boolean;
}

const NewItemBadge = ({ isNew }: NewItemBadgeProps) => {
  const { t } = useTranslation('common');

  if (!isNew) return null;

  return (
    <Chip
      label={t('newItem')}
      color="success"
      size="small"
      sx={{ height: 20, ml: 1, verticalAlign: 'middle' }}
    />
  );
};

export default NewItemBadge;